import React, { FC } from 'react'
import cn from 'classnames'

import { BrandingLogo } from '@/layout/branding-theme'

type BrandedSidePanelProps = { className?: string }

/**
 * A reseller's side panel for the login and sign-up pages: their primary colour behind a
 * grid of lines, with their logo on a tile at its edge, in place of Grid's illustration.
 */
export const BrandedSidePanel: FC<BrandedSidePanelProps> = ({ className }) => (
  <div
    className={cn(
      'flex items-center justify-end bg-primary-main',
      // The tile is one grid cell, so anchoring the lines on the same edge lines the two up.
      '[background-image:linear-gradient(rgba(255,255,255,0.4)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.4)_1px,transparent_1px)]',
      '[background-position:right_center] [background-size:360px_360px]',
      className,
    )}
    data-testid="branded-side-panel"
  >
    <div className="flex size-[360px] items-center justify-center bg-gray-6-filled p-12">
      <BrandingLogo className="max-h-full max-w-full object-contain" />
    </div>
  </div>
)
